module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/HK-102bd95ee647382b2dea0845580c4314.png";